export const wrapperIdentifier = 'targetTypes';

export interface TargetType {
  id: string;
}
